import PropTypes from "prop-types"
import { Typography } from "@mui/material"
import SkillCard from "connected-components/skills/components/skill-card"
import type { SkillSection } from "connected-components/skills/types"

import "./style.scss"

interface SkillsSectionProps {
  section: SkillSection
}

function SkillsSection({ section }: SkillsSectionProps) {
  return (
    <section className="skills-section">
      <Typography variant="h5" component="h2" className="skills-section-title">
        {section.title}
      </Typography>
      <div className="skills-section-grid">
        {section.skills.map(skill => (
          <SkillCard
            key={`${skill.tier}-${skill.id}`}
            skill={skill}
          />
        ))}
      </div>
    </section>
  )
}

SkillsSection.propTypes = {
  section: PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    skills: PropTypes.array.isRequired,
  }).isRequired,
}

export default SkillsSection
